export default [
  {
    text: "省政府办公厅转发省发展改革委等部门关于清理规范城镇供水供电供气供暖行业收费促进行业高质量发展实施方案的通知",
    url: "/pdf/getpriceXmbz/省政府办公厅转发省发展改革委等部门关于清理规范城镇供水供电供气供暖行业收费促进行业高质量发展实施方案的通知.pdf",
  },
  {
    text: "国务院办公厅转发国家发展改革委等部门关于清理规范城镇供水供电供气供暖行业收费促进行业高质量发展意见的通知",
    url: "/pdf/getpriceXmbz/国务院办公厅转发国家发展改革委等部门关于清理规范城镇供水供电供气供暖行业收费促进行业高质量发展意见的通知.pdf",
  },
];
